// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BeneficiariesReport_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, firstGrantorDeath: { __typename?: 'ClientProfile', id: string }, beneficiaryReport: (
    { __typename?: 'EstateWaterfallBeneficiaryReport' }
    & BeneficiariesReport_EstateWaterfallBeneficiaryReportFragment
  ) };

export type BeneficiariesReport_EstateWaterfallBeneficiaryReportFragment = { __typename?: 'EstateWaterfallBeneficiaryReport', _cacheKey: string, beneficiariesMissingDateOfBirth?: Array<(
    { __typename?: 'ClientProfile' }
    & BeneficiariesReport_ClientProfileFragment
  ) | null> | null, beneficiariesBreakdown?: Array<(
    { __typename?: 'BeneficiaryReportBeneficiaryBreakdown' }
    & BeneficiariesReport_BeneficiaryReportBeneficiaryBreakdownFragment
  )> | null, materializedInputParams: (
    { __typename?: 'EstateWaterfallMaterializedInputParams' }
    & BeneficiariesReport_EstateWaterfallMaterializedInputParamsFragment
  ) };

export type BeneficiariesReport_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, dateOfBirth?: Time | null, firstName: string, preferredName?: string | null, lastName: string, pastDistributions?: CurrencyUSD | null, relationships?: Array<{ __typename?: 'ClientProfileRelationship', id: string, type: Types.ClientProfileRelationshipType, toClientProfile: { __typename?: 'ClientProfile', id: string, firstName: string } }> | null };

export type BeneficiariesReport_BeneficiaryReportYearByYearBeneficiaryAccessFragment = { __typename?: 'BeneficiaryReportYearByYearBeneficiaryAccess', _cacheKey: string, age?: number | null, distributionsToDate: CurrencyUSD, milestones?: Array<string> | null, newTrustAccess?: CurrencyUSD | null, trustAccessToDate: CurrencyUSD, year: number };

export type BeneficiariesReport_Node_AiSuggestion_Fragment = { __typename: 'AISuggestion', id: string };

export type BeneficiariesReport_Node_AiSuggestionEvidence_Fragment = { __typename: 'AISuggestionEvidence', id: string };

export type BeneficiariesReport_Node_AccessAgeParameter_Fragment = { __typename: 'AccessAgeParameter', id: string };

export type BeneficiariesReport_Node_AccessParameter_Fragment = { __typename: 'AccessParameter', id: string };

export type BeneficiariesReport_Node_Account_Fragment = { __typename: 'Account', id: string };

export type BeneficiariesReport_Node_ActiveEstateInsightsPage_Fragment = { __typename: 'ActiveEstateInsightsPage', id: string };

export type BeneficiariesReport_Node_Activity_Fragment = { __typename: 'Activity', id: string };

export type BeneficiariesReport_Node_Address_Fragment = { __typename: 'Address', id: string };

export type BeneficiariesReport_Node_Answer_Fragment = { __typename: 'Answer', id: string };

export type BeneficiariesReport_Node_AnswerEvidence_Fragment = { __typename: 'AnswerEvidence', id: string };

export type BeneficiariesReport_Node_AnswerRevision_Fragment = { __typename: 'AnswerRevision', id: string };

export type BeneficiariesReport_Node_Approval_Fragment = { __typename: 'Approval', id: string };

export type BeneficiariesReport_Node_AssetClass_Fragment = { __typename: 'AssetClass', id: string };

export type BeneficiariesReport_Node_AssetGroup_Fragment = { __typename: 'AssetGroup', id: string };

export type BeneficiariesReport_Node_AssetStatic_Fragment = { __typename: 'AssetStatic', id: string };

export type BeneficiariesReport_Node_AssetV2_Fragment = { __typename: 'AssetV2', id: string };

export type BeneficiariesReport_Node_AssetValuationV2_Fragment = { __typename: 'AssetValuationV2', id: string };

export type BeneficiariesReport_Node_AssetValueV2_Fragment = { __typename: 'AssetValueV2', id: string };

export type BeneficiariesReport_Node_AsyncJob_Fragment = { __typename: 'AsyncJob', id: string };

export type BeneficiariesReport_Node_BalanceSheetBundleConfiguration_Fragment = { __typename: 'BalanceSheetBundleConfiguration', id: string };

export type BeneficiariesReport_Node_BalanceSheetCategory_Fragment = { __typename: 'BalanceSheetCategory', id: string };

export type BeneficiariesReport_Node_BalanceSheetViewConfiguration_Fragment = { __typename: 'BalanceSheetViewConfiguration', id: string };

export type BeneficiariesReport_Node_BeneficiariesBundleConfiguration_Fragment = { __typename: 'BeneficiariesBundleConfiguration', id: string };

export type BeneficiariesReport_Node_BeneficiariesTemplateBundleConfiguration_Fragment = { __typename: 'BeneficiariesTemplateBundleConfiguration', id: string };

export type BeneficiariesReport_Node_Beneficiary_Fragment = { __typename: 'Beneficiary', id: string };

export type BeneficiariesReport_Node_BeneficiaryAccessParameter_Fragment = { __typename: 'BeneficiaryAccessParameter', id: string };

export type BeneficiariesReport_Node_BeneficiaryDesignationGroup_Fragment = { __typename: 'BeneficiaryDesignationGroup', id: string };

export type BeneficiariesReport_Node_BeneficiaryDistribution_Fragment = { __typename: 'BeneficiaryDistribution', id: string };

export type BeneficiariesReport_Node_BeneficiaryDistributionParameter_Fragment = { __typename: 'BeneficiaryDistributionParameter', id: string };

export type BeneficiariesReport_Node_BeneficiaryPage_Fragment = { __typename: 'BeneficiaryPage', id: string };

export type BeneficiariesReport_Node_BeneficiaryPowerOfAppointment_Fragment = { __typename: 'BeneficiaryPowerOfAppointment', id: string };

export type BeneficiariesReport_Node_CCorpBusinessEntity_Fragment = { __typename: 'CCorpBusinessEntity', id: string };

export type BeneficiariesReport_Node_CltProposal_Fragment = { __typename: 'CLTProposal', id: string };

export type BeneficiariesReport_Node_CltTrust_Fragment = { __typename: 'CLTTrust', id: string };

export type BeneficiariesReport_Node_CrtProposal_Fragment = { __typename: 'CRTProposal', id: string };

export type BeneficiariesReport_Node_CrtTrust_Fragment = { __typename: 'CRTTrust', id: string };

export type BeneficiariesReport_Node_Capability_Fragment = { __typename: 'Capability', id: string };

export type BeneficiariesReport_Node_Cashflow_Fragment = { __typename: 'Cashflow', id: string };

export type BeneficiariesReport_Node_ClientOrganization_Fragment = { __typename: 'ClientOrganization', id: string };

export type BeneficiariesReport_Node_ClientPresentationV2_Fragment = { __typename: 'ClientPresentationV2', id: string };

export type BeneficiariesReport_Node_ClientProfile_Fragment = { __typename: 'ClientProfile', id: string };

export type BeneficiariesReport_Node_ClientProfileRelationship_Fragment = { __typename: 'ClientProfileRelationship', id: string };

export type BeneficiariesReport_Node_Collaborator_Fragment = { __typename: 'Collaborator', id: string };

export type BeneficiariesReport_Node_ComparedWaterfall_Fragment = { __typename: 'ComparedWaterfall', id: string };

export type BeneficiariesReport_Node_CompletedEstateInsightsPage_Fragment = { __typename: 'CompletedEstateInsightsPage', id: string };

export type BeneficiariesReport_Node_ControllingParty_Fragment = { __typename: 'ControllingParty', id: string };

export type BeneficiariesReport_Node_Conversation_Fragment = { __typename: 'Conversation', id: string };

export type BeneficiariesReport_Node_CoverPageConfiguration_Fragment = { __typename: 'CoverPageConfiguration', id: string };

export type BeneficiariesReport_Node_CustodialPersonalAccount_Fragment = { __typename: 'CustodialPersonalAccount', id: string };

export type BeneficiariesReport_Node_DsuePortability_Fragment = { __typename: 'DSUEPortability', id: string };

export type BeneficiariesReport_Node_DiagramArtifact_Fragment = { __typename: 'DiagramArtifact', id: string };

export type BeneficiariesReport_Node_DiagramArtifactPrompt_Fragment = { __typename: 'DiagramArtifactPrompt', id: string };

export type BeneficiariesReport_Node_DispositionScenario_Fragment = { __typename: 'DispositionScenario', id: string };

export type BeneficiariesReport_Node_DispositiveProvision_Fragment = { __typename: 'DispositiveProvision', id: string };

export type BeneficiariesReport_Node_DispositiveProvisionTemplate_Fragment = { __typename: 'DispositiveProvisionTemplate', id: string };

export type BeneficiariesReport_Node_DividerBundleConfiguration_Fragment = { __typename: 'DividerBundleConfiguration', id: string };

export type BeneficiariesReport_Node_DividerTemplateBundleConfiguration_Fragment = { __typename: 'DividerTemplateBundleConfiguration', id: string };

export type BeneficiariesReport_Node_Document_Fragment = { __typename: 'Document', id: string };

export type BeneficiariesReport_Node_DocumentQuestion_Fragment = { __typename: 'DocumentQuestion', id: string };

export type BeneficiariesReport_Node_DocumentQuestionAnswers_Fragment = { __typename: 'DocumentQuestionAnswers', id: string };

export type BeneficiariesReport_Node_DocumentSummary_Fragment = { __typename: 'DocumentSummary', id: string };

export type BeneficiariesReport_Node_DocumentSummaryPage_Fragment = { __typename: 'DocumentSummaryPage', id: string };

export type BeneficiariesReport_Node_DocumentSummaryPrompt_Fragment = { __typename: 'DocumentSummaryPrompt', id: string };

export type BeneficiariesReport_Node_DocumentSummaryPromptTestRun_Fragment = { __typename: 'DocumentSummaryPromptTestRun', id: string };

export type BeneficiariesReport_Node_DocumentSummaryTemplateBundleConfiguration_Fragment = { __typename: 'DocumentSummaryTemplateBundleConfiguration', id: string };

export type BeneficiariesReport_Node_DonorAdvisedFund_Fragment = { __typename: 'DonorAdvisedFund', id: string };

export type BeneficiariesReport_Node_Employee_Fragment = { __typename: 'Employee', id: string };

export type BeneficiariesReport_Node_EntitiesOverviewBundleConfiguration_Fragment = { __typename: 'EntitiesOverviewBundleConfiguration', id: string };

export type BeneficiariesReport_Node_EntitiesOverviewBundleConfigurationEntity_Fragment = { __typename: 'EntitiesOverviewBundleConfigurationEntity', id: string };

export type BeneficiariesReport_Node_Entity_Fragment = { __typename: 'Entity', id: string, entityKind: Types.EntityKind };

export type BeneficiariesReport_Node_EntityDiagram_Fragment = { __typename: 'EntityDiagram', id: string };

export type BeneficiariesReport_Node_EntityDocumentRelationship_Fragment = { __typename: 'EntityDocumentRelationship', id: string };

export type BeneficiariesReport_Node_EntityGraphView_Fragment = { __typename: 'EntityGraphView', id: string };

export type BeneficiariesReport_Node_EntityGraphViewBundleConfiguration_Fragment = { __typename: 'EntityGraphViewBundleConfiguration', id: string };

export type BeneficiariesReport_Node_EntityNotes_Fragment = { __typename: 'EntityNotes', id: string };

export type BeneficiariesReport_Node_EntityProposal_Fragment = { __typename: 'EntityProposal', id: string };

export type BeneficiariesReport_Node_EntitySummaryBundleConfiguration_Fragment = { __typename: 'EntitySummaryBundleConfiguration', id: string };

export type BeneficiariesReport_Node_EntitySummaryTemplateBundleConfiguration_Fragment = { __typename: 'EntitySummaryTemplateBundleConfiguration', id: string };

export type BeneficiariesReport_Node_EntityTask_Fragment = { __typename: 'EntityTask', id: string };

export type BeneficiariesReport_Node_EntityTaxInfo_Fragment = { __typename: 'EntityTaxInfo', id: string };

export type BeneficiariesReport_Node_EstateInsight_Fragment = { __typename: 'EstateInsight', id: string };

export type BeneficiariesReport_Node_EstateInsightReference_Fragment = { __typename: 'EstateInsightReference', id: string };

export type BeneficiariesReport_Node_EstateInsightsBundleConfiguration_Fragment = { __typename: 'EstateInsightsBundleConfiguration', id: string };

export type BeneficiariesReport_Node_EstateTaxScenario_Fragment = { __typename: 'EstateTaxScenario', id: string };

export type BeneficiariesReport_Node_EstateWaterfall_Fragment = { __typename: 'EstateWaterfall', id: string };

export type BeneficiariesReport_Node_EstateWaterfallHypotheticalStateChange_Fragment = { __typename: 'EstateWaterfallHypotheticalStateChange', id: string };

export type BeneficiariesReport_Node_EstateWaterfallHypotheticalTransfer_Fragment = { __typename: 'EstateWaterfallHypotheticalTransfer', id: string };

export type BeneficiariesReport_Node_EstateWaterfallMessageContext_Fragment = { __typename: 'EstateWaterfallMessageContext', id: string };

export type BeneficiariesReport_Node_EstateWaterfallVisualizationConfig_Fragment = { __typename: 'EstateWaterfallVisualizationConfig', id: string };

export type BeneficiariesReport_Node_EstateWaterfallVisualizationFilter_Fragment = { __typename: 'EstateWaterfallVisualizationFilter', id: string };

export type BeneficiariesReport_Node_FamilyTreeBundleConfiguration_Fragment = { __typename: 'FamilyTreeBundleConfiguration', id: string };

export type BeneficiariesReport_Node_FamilyTreeConfiguration_Fragment = { __typename: 'FamilyTreeConfiguration', id: string };

export type BeneficiariesReport_Node_FeatureFlag_Fragment = { __typename: 'FeatureFlag', id: string };

export type BeneficiariesReport_Node_FeatureFlagQueryRule_Fragment = { __typename: 'FeatureFlagQueryRule', id: string };

export type BeneficiariesReport_Node_File_Fragment = { __typename: 'File', id: string };

export type BeneficiariesReport_Node_FilePage_Fragment = { __typename: 'FilePage', id: string };

export type BeneficiariesReport_Node_FileParagraph_Fragment = { __typename: 'FileParagraph', id: string };

export type BeneficiariesReport_Node_Form_Fragment = { __typename: 'Form', id: string };

export type BeneficiariesReport_Node_FormVersion_Fragment = { __typename: 'FormVersion', id: string };

export type BeneficiariesReport_Node_GpBusinessEntity_Fragment = { __typename: 'GPBusinessEntity', id: string };

export type BeneficiariesReport_Node_GratAnnuityV2_Fragment = { __typename: 'GRATAnnuityV2', id: string };

export type BeneficiariesReport_Node_GratProposalScenario_Fragment = { __typename: 'GRATProposalScenario', id: string };

export type BeneficiariesReport_Node_GratTrust_Fragment = { __typename: 'GRATTrust', id: string };

export type BeneficiariesReport_Node_GiftingProposal_Fragment = { __typename: 'GiftingProposal', id: string };

export type BeneficiariesReport_Node_GiftingProposalCashFlow_Fragment = { __typename: 'GiftingProposalCashFlow', id: string };

export type BeneficiariesReport_Node_GiftingProposalGift_Fragment = { __typename: 'GiftingProposalGift', id: string };

export type BeneficiariesReport_Node_GiftingProposalGiftSender_Fragment = { __typename: 'GiftingProposalGiftSender', id: string };

export type BeneficiariesReport_Node_GiftingProposalPortfolio_Fragment = { __typename: 'GiftingProposalPortfolio', id: string };

export type BeneficiariesReport_Node_GiftingProposalScenario_Fragment = { __typename: 'GiftingProposalScenario', id: string };

export type BeneficiariesReport_Node_GraphVisualizationGroup_Fragment = { __typename: 'GraphVisualizationGroup', id: string };

export type BeneficiariesReport_Node_GrowthProfile_Fragment = { __typename: 'GrowthProfile', id: string };

export type BeneficiariesReport_Node_GrowthProfileOverride_Fragment = { __typename: 'GrowthProfileOverride', id: string };

export type BeneficiariesReport_Node_Household_Fragment = { __typename: 'Household', id: string };

export type BeneficiariesReport_Node_HypotheticalClt_Fragment = { __typename: 'HypotheticalCLT', id: string };

export type BeneficiariesReport_Node_HypotheticalCrt_Fragment = { __typename: 'HypotheticalCRT', id: string };

export type BeneficiariesReport_Node_HypotheticalGrat_Fragment = { __typename: 'HypotheticalGRAT', id: string, simulatedGrat: { __typename?: 'Entity', id: string } };

export type BeneficiariesReport_Node_HypotheticalInsurance_Fragment = { __typename: 'HypotheticalInsurance', id: string };

export type BeneficiariesReport_Node_HypotheticalSaleLoan_Fragment = { __typename: 'HypotheticalSaleLoan', id: string };

export type BeneficiariesReport_Node_HypotheticalTransferAsset_Fragment = { __typename: 'HypotheticalTransferAsset', id: string };

export type BeneficiariesReport_Node_HypotheticalTransferFundingSource_Fragment = { __typename: 'HypotheticalTransferFundingSource', id: string };

export type BeneficiariesReport_Node_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment = { __typename: 'HypotheticalWaterfallDispositiveProvisionTemplate', id: string };

export type BeneficiariesReport_Node_IlitCrummeyLetter_Fragment = { __typename: 'ILITCrummeyLetter', id: string };

export type BeneficiariesReport_Node_IlitTrust_Fragment = { __typename: 'ILITTrust', id: string };

export type BeneficiariesReport_Node_Image_Fragment = { __typename: 'Image', id: string };

export type BeneficiariesReport_Node_IncomeTaxPaymentConfig_Fragment = { __typename: 'IncomeTaxPaymentConfig', id: string };

export type BeneficiariesReport_Node_IndividualPersonalAccount_Fragment = { __typename: 'IndividualPersonalAccount', id: string };

export type BeneficiariesReport_Node_InferredField_Fragment = { __typename: 'InferredField', id: string };

export type BeneficiariesReport_Node_InferredFieldEvidence_Fragment = { __typename: 'InferredFieldEvidence', id: string };

export type BeneficiariesReport_Node_InsightsTemplateBundleConfiguration_Fragment = { __typename: 'InsightsTemplateBundleConfiguration', id: string };

export type BeneficiariesReport_Node_InsurancePersonalAccount_Fragment = { __typename: 'InsurancePersonalAccount', id: string };

export type BeneficiariesReport_Node_InsurancePolicy_Fragment = { __typename: 'InsurancePolicy', id: string };

export type BeneficiariesReport_Node_InsurancePremiumPayment_Fragment = { __typename: 'InsurancePremiumPayment', id: string };

export type BeneficiariesReport_Node_IntegrationAssetClass_Fragment = { __typename: 'IntegrationAssetClass', id: string };

export type BeneficiariesReport_Node_IntegrationCashflow_Fragment = { __typename: 'IntegrationCashflow', id: string };

export type BeneficiariesReport_Node_IntegrationClient_Fragment = { __typename: 'IntegrationClient', id: string };

export type BeneficiariesReport_Node_IntegrationConfiguration_Fragment = { __typename: 'IntegrationConfiguration', id: string };

export type BeneficiariesReport_Node_IntegrationEntity_Fragment = { __typename: 'IntegrationEntity', id: string };

export type BeneficiariesReport_Node_IntegrationInsurance_Fragment = { __typename: 'IntegrationInsurance', id: string };

export type BeneficiariesReport_Node_IntegrationLiability_Fragment = { __typename: 'IntegrationLiability', id: string };

export type BeneficiariesReport_Node_IntegrationPerson_Fragment = { __typename: 'IntegrationPerson', id: string };

export type BeneficiariesReport_Node_IrrevocableTrust_Fragment = { __typename: 'IrrevocableTrust', id: string };

export type BeneficiariesReport_Node_JointPersonalAccount_Fragment = { __typename: 'JointPersonalAccount', id: string };

export type BeneficiariesReport_Node_KgNode_Fragment = { __typename: 'KGNode', id: string };

export type BeneficiariesReport_Node_KgRelationship_Fragment = { __typename: 'KGRelationship', id: string };

export type BeneficiariesReport_Node_KgRoot_Fragment = { __typename: 'KGRoot', id: string };

export type BeneficiariesReport_Node_Kgv2Document_Fragment = { __typename: 'KGV2Document', id: string };

export type BeneficiariesReport_Node_Kgv2DocumentChange_Fragment = { __typename: 'KGV2DocumentChange', id: string };

export type BeneficiariesReport_Node_Kgv2DocumentModification_Fragment = { __typename: 'KGV2DocumentModification', id: string };

export type BeneficiariesReport_Node_Kgv2Graph_Fragment = { __typename: 'KGV2Graph', id: string };

export type BeneficiariesReport_Node_Kgv2Node_Fragment = { __typename: 'KGV2Node', id: string };

export type BeneficiariesReport_Node_Kgv2NodeAlias_Fragment = { __typename: 'KGV2NodeAlias', id: string };

export type BeneficiariesReport_Node_Kgv2NodeEvidence_Fragment = { __typename: 'KGV2NodeEvidence', id: string };

export type BeneficiariesReport_Node_Kgv2Statement_Fragment = { __typename: 'KGV2Statement', id: string };

export type BeneficiariesReport_Node_Kgv2StatementEvidence_Fragment = { __typename: 'KGV2StatementEvidence', id: string };

export type BeneficiariesReport_Node_Kgv2StatementSupersession_Fragment = { __typename: 'KGV2StatementSupersession', id: string };

export type BeneficiariesReport_Node_KeyPerson_Fragment = { __typename: 'KeyPerson', id: string };

export type BeneficiariesReport_Node_KeyPersonRole_Fragment = { __typename: 'KeyPersonRole', id: string };

export type BeneficiariesReport_Node_LlcBusinessEntity_Fragment = { __typename: 'LLCBusinessEntity', id: string };

export type BeneficiariesReport_Node_LpBusinessEntity_Fragment = { __typename: 'LPBusinessEntity', id: string };

export type BeneficiariesReport_Node_LiabilitiesBundleConfiguration_Fragment = { __typename: 'LiabilitiesBundleConfiguration', id: string };

export type BeneficiariesReport_Node_Liability_Fragment = { __typename: 'Liability', id: string };

export type BeneficiariesReport_Node_LiabilityPayment_Fragment = { __typename: 'LiabilityPayment', id: string };

export type BeneficiariesReport_Node_LifeInsuranceBundleConfiguration_Fragment = { __typename: 'LifeInsuranceBundleConfiguration', id: string };

export type BeneficiariesReport_Node_LifetimeExclusionEvent_Fragment = { __typename: 'LifetimeExclusionEvent', id: string };

export type BeneficiariesReport_Node_LoggedTransfer_Fragment = { __typename: 'LoggedTransfer', id: string };

export type BeneficiariesReport_Node_LuminaryOrganization_Fragment = { __typename: 'LuminaryOrganization', id: string };

export type BeneficiariesReport_Node_LuminaryTenantJit_Fragment = { __typename: 'LuminaryTenantJIT', id: string };

export type BeneficiariesReport_Node_ManagedSftpConnection_Fragment = { __typename: 'ManagedSFTPConnection', id: string };

export type BeneficiariesReport_Node_Memo_Fragment = { __typename: 'Memo', id: string };

export type BeneficiariesReport_Node_MemoPrompt_Fragment = { __typename: 'MemoPrompt', id: string };

export type BeneficiariesReport_Node_Message_Fragment = { __typename: 'Message', id: string };

export type BeneficiariesReport_Node_MissingDocumentOverride_Fragment = { __typename: 'MissingDocumentOverride', id: string };

export type BeneficiariesReport_Node_MissingDocumentsPage_Fragment = { __typename: 'MissingDocumentsPage', id: string };

export type BeneficiariesReport_Node_ModelMapping_Fragment = { __typename: 'ModelMapping', id: string };

export type BeneficiariesReport_Node_NotificationApp_Fragment = { __typename: 'NotificationApp', id: string };

export type BeneficiariesReport_Node_NotificationPreference_Fragment = { __typename: 'NotificationPreference', id: string };

export type BeneficiariesReport_Node_OpenaiSdkConfig_Fragment = { __typename: 'OpenaiSdkConfig', id: string };

export type BeneficiariesReport_Node_OrganizationApplicationConfiguration_Fragment = { __typename: 'OrganizationApplicationConfiguration', id: string };

export type BeneficiariesReport_Node_OrganizationDisclaimerConfiguration_Fragment = { __typename: 'OrganizationDisclaimerConfiguration', id: string };

export type BeneficiariesReport_Node_OwnershipStake_Fragment = { __typename: 'OwnershipStake', id: string };

export type BeneficiariesReport_Node_PlatformDocument_Fragment = { __typename: 'PlatformDocument', id: string };

export type BeneficiariesReport_Node_PlatformFile_Fragment = { __typename: 'PlatformFile', id: string };

export type BeneficiariesReport_Node_PlatformFilePage_Fragment = { __typename: 'PlatformFilePage', id: string };

export type BeneficiariesReport_Node_PlatformFileParagraph_Fragment = { __typename: 'PlatformFileParagraph', id: string };

export type BeneficiariesReport_Node_PresentationApprovalRequest_Fragment = { __typename: 'PresentationApprovalRequest', id: string };

export type BeneficiariesReport_Node_PresentationAssetDistributionBundleConfiguration_Fragment = { __typename: 'PresentationAssetDistributionBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationAssetDistributionItemConfiguration_Fragment = { __typename: 'PresentationAssetDistributionItemConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationAssetDistributionItemDetail_Fragment = { __typename: 'PresentationAssetDistributionItemDetail', id: string };

export type BeneficiariesReport_Node_PresentationBundle_Fragment = { __typename: 'PresentationBundle', id: string };

export type BeneficiariesReport_Node_PresentationBundleCoverPage_Fragment = { __typename: 'PresentationBundleCoverPage', id: string };

export type BeneficiariesReport_Node_PresentationBusinessOverviewBundleConfiguration_Fragment = { __typename: 'PresentationBusinessOverviewBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationBusinessOverviewBusinessConfiguration_Fragment = { __typename: 'PresentationBusinessOverviewBusinessConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationBusinessOverviewItem_Fragment = { __typename: 'PresentationBusinessOverviewItem', id: string };

export type BeneficiariesReport_Node_PresentationCoverPage_Fragment = { __typename: 'PresentationCoverPage', id: string };

export type BeneficiariesReport_Node_PresentationCoverSlideConfig_Fragment = { __typename: 'PresentationCoverSlideConfig', id: string };

export type BeneficiariesReport_Node_PresentationCustomPage_Fragment = { __typename: 'PresentationCustomPage', id: string };

export type BeneficiariesReport_Node_PresentationCustomPageBundleConfiguration_Fragment = { __typename: 'PresentationCustomPageBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationDiagramPage_Fragment = { __typename: 'PresentationDiagramPage', id: string };

export type BeneficiariesReport_Node_PresentationDocumentsReviewedBundleConfiguration_Fragment = { __typename: 'PresentationDocumentsReviewedBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationDocumentsReviewedDocument_Fragment = { __typename: 'PresentationDocumentsReviewedDocument', id: string };

export type BeneficiariesReport_Node_PresentationFamilyOverviewBundleConfiguration_Fragment = { __typename: 'PresentationFamilyOverviewBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationFamilyOverviewMemberConfiguration_Fragment = { __typename: 'PresentationFamilyOverviewMemberConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationHealthcareDirectiveBundleConfiguration_Fragment = { __typename: 'PresentationHealthcareDirectiveBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationHealthcareDirectiveClientConfiguration_Fragment = { __typename: 'PresentationHealthcareDirectiveClientConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationHealthcareDirectiveItem_Fragment = { __typename: 'PresentationHealthcareDirectiveItem', id: string };

export type BeneficiariesReport_Node_PresentationItemCitation_Fragment = { __typename: 'PresentationItemCitation', id: string };

export type BeneficiariesReport_Node_PresentationPage_Fragment = { __typename: 'PresentationPage', id: string };

export type BeneficiariesReport_Node_PresentationPlanningOpportunitiesBundleConfiguration_Fragment = { __typename: 'PresentationPlanningOpportunitiesBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationPlanningOpportunitiesItem_Fragment = { __typename: 'PresentationPlanningOpportunitiesItem', id: string };

export type BeneficiariesReport_Node_PresentationPowerOfAttorneyBundleConfiguration_Fragment = { __typename: 'PresentationPowerOfAttorneyBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationPowerOfAttorneyClientConfiguration_Fragment = { __typename: 'PresentationPowerOfAttorneyClientConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationPowerOfAttorneyItem_Fragment = { __typename: 'PresentationPowerOfAttorneyItem', id: string };

export type BeneficiariesReport_Node_PresentationTemplate_Fragment = { __typename: 'PresentationTemplate', id: string };

export type BeneficiariesReport_Node_PresentationTemplateBundle_Fragment = { __typename: 'PresentationTemplateBundle', id: string };

export type BeneficiariesReport_Node_PresentationTemplateCoverPage_Fragment = { __typename: 'PresentationTemplateCoverPage', id: string };

export type BeneficiariesReport_Node_PresentationTemplateCustomPage_Fragment = { __typename: 'PresentationTemplateCustomPage', id: string };

export type BeneficiariesReport_Node_PresentationTemplateDiagramPage_Fragment = { __typename: 'PresentationTemplateDiagramPage', id: string };

export type BeneficiariesReport_Node_PresentationTemplatePage_Fragment = { __typename: 'PresentationTemplatePage', id: string };

export type BeneficiariesReport_Node_PresentationTrustOverviewBundleConfiguration_Fragment = { __typename: 'PresentationTrustOverviewBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationTrustOverviewItem_Fragment = { __typename: 'PresentationTrustOverviewItem', id: string };

export type BeneficiariesReport_Node_PresentationTrustOverviewTrustConfiguration_Fragment = { __typename: 'PresentationTrustOverviewTrustConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationWillBundleConfiguration_Fragment = { __typename: 'PresentationWillBundleConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationWillClientConfiguration_Fragment = { __typename: 'PresentationWillClientConfiguration', id: string };

export type BeneficiariesReport_Node_PresentationWillItem_Fragment = { __typename: 'PresentationWillItem', id: string };

export type BeneficiariesReport_Node_Principal_Fragment = { __typename: 'Principal', id: string };

export type BeneficiariesReport_Node_PrivateFoundation_Fragment = { __typename: 'PrivateFoundation', id: string };

export type BeneficiariesReport_Node_ProfessionalTeamRole_Fragment = { __typename: 'ProfessionalTeamRole', id: string };

export type BeneficiariesReport_Node_Proposal_Fragment = { __typename: 'Proposal', id: string, cltProposal?: { __typename?: 'CLTProposal', id: string } | null, crtProposal?: { __typename?: 'CRTProposal', id: string } | null };

export type BeneficiariesReport_Node_ProposalScenario_Fragment = { __typename: 'ProposalScenario', id: string };

export type BeneficiariesReport_Node_QprtTrust_Fragment = { __typename: 'QPRTTrust', id: string };

export type BeneficiariesReport_Node_QualifiedTuitionPersonalAccount_Fragment = { __typename: 'QualifiedTuitionPersonalAccount', id: string };

export type BeneficiariesReport_Node_ReleaseGroup_Fragment = { __typename: 'ReleaseGroup', id: string };

export type BeneficiariesReport_Node_ReminderEmailNotificationRecord_Fragment = { __typename: 'ReminderEmailNotificationRecord', id: string };

export type BeneficiariesReport_Node_RetirementPersonalAccount_Fragment = { __typename: 'RetirementPersonalAccount', id: string };

export type BeneficiariesReport_Node_RevocableTrust_Fragment = { __typename: 'RevocableTrust', id: string };

export type BeneficiariesReport_Node_Role_Fragment = { __typename: 'Role', id: string };

export type BeneficiariesReport_Node_SCorpBusinessEntity_Fragment = { __typename: 'SCorpBusinessEntity', id: string };

export type BeneficiariesReport_Node_SlatTrust_Fragment = { __typename: 'SLATTrust', id: string };

export type BeneficiariesReport_Node_SsoConnection_Fragment = { __typename: 'SSOConnection', id: string };

export type BeneficiariesReport_Node_SalesforceExportAttempt_Fragment = { __typename: 'SalesforceExportAttempt', id: string };

export type BeneficiariesReport_Node_ScheduledDistribution_Fragment = { __typename: 'ScheduledDistribution', id: string };

export type BeneficiariesReport_Node_SoleProprietorshipBusinessEntity_Fragment = { __typename: 'SoleProprietorshipBusinessEntity', id: string };

export type BeneficiariesReport_Node_SubBrand_Fragment = { __typename: 'SubBrand', id: string };

export type BeneficiariesReport_Node_SubBrandDisclaimerConfiguration_Fragment = { __typename: 'SubBrandDisclaimerConfiguration', id: string };

export type BeneficiariesReport_Node_Submission_Fragment = { __typename: 'Submission', id: string };

export type BeneficiariesReport_Node_TaxDragConfig_Fragment = { __typename: 'TaxDragConfig', id: string };

export type BeneficiariesReport_Node_TaxDragOverride_Fragment = { __typename: 'TaxDragOverride', id: string };

export type BeneficiariesReport_Node_Team_Fragment = { __typename: 'Team', id: string };

export type BeneficiariesReport_Node_Tenant_Fragment = { __typename: 'Tenant', id: string };

export type BeneficiariesReport_Node_TenantApplicationConfiguration_Fragment = { __typename: 'TenantApplicationConfiguration', id: string };

export type BeneficiariesReport_Node_TenantBranding_Fragment = { __typename: 'TenantBranding', id: string };

export type BeneficiariesReport_Node_TenantDisclaimerConfiguration_Fragment = { __typename: 'TenantDisclaimerConfiguration', id: string };

export type BeneficiariesReport_Node_TenantDocument_Fragment = { __typename: 'TenantDocument', id: string };

export type BeneficiariesReport_Node_TenantReminderEmailsConfiguration_Fragment = { __typename: 'TenantReminderEmailsConfiguration', id: string };

export type BeneficiariesReport_Node_TenantSsoConnection_Fragment = { __typename: 'TenantSSOConnection', id: string };

export type BeneficiariesReport_Node_TenantSecurityConfiguration_Fragment = { __typename: 'TenantSecurityConfiguration', id: string };

export type BeneficiariesReport_Node_TenantSlideConfig_Fragment = { __typename: 'TenantSlideConfig', id: string };

export type BeneficiariesReport_Node_TestCmkEncryption_Fragment = { __typename: 'TestCMKEncryption', id: string };

export type BeneficiariesReport_Node_TestamentaryEntity_Fragment = { __typename: 'TestamentaryEntity', id: string };

export type BeneficiariesReport_Node_TrustAdvisor_Fragment = { __typename: 'TrustAdvisor', id: string };

export type BeneficiariesReport_Node_TrustAdvisorRole_Fragment = { __typename: 'TrustAdvisorRole', id: string };

export type BeneficiariesReport_Node_Trustee_Fragment = { __typename: 'Trustee', id: string };

export type BeneficiariesReport_Node_TrusteeDuty_Fragment = { __typename: 'TrusteeDuty', id: string };

export type BeneficiariesReport_Node_User_Fragment = { __typename: 'User', id: string };

export type BeneficiariesReport_Node_UserFeedback_Fragment = { __typename: 'UserFeedback', id: string };

export type BeneficiariesReport_Node_UserNotificationConfiguration_Fragment = { __typename: 'UserNotificationConfiguration', id: string };

export type BeneficiariesReport_Node_WaterfallBundleConfiguration_Fragment = { __typename: 'WaterfallBundleConfiguration', id: string };

export type BeneficiariesReport_Node_WaterfallBundleCoverPage_Fragment = { __typename: 'WaterfallBundleCoverPage', id: string };

export type BeneficiariesReport_Node_WaterfallComparisonBundleConfiguration_Fragment = { __typename: 'WaterfallComparisonBundleConfiguration', id: string };

export type BeneficiariesReport_Node_WaterfallComparisonTemplateBundleConfiguration_Fragment = { __typename: 'WaterfallComparisonTemplateBundleConfiguration', id: string };

export type BeneficiariesReport_Node_WaterfallTemplateBundleConfiguration_Fragment = { __typename: 'WaterfallTemplateBundleConfiguration', id: string };

export type BeneficiariesReport_Node_WorkOsOrganization_Fragment = { __typename: 'WorkOSOrganization', id: string };

export type BeneficiariesReport_Node_WorkOsOrganizationDomain_Fragment = { __typename: 'WorkOSOrganizationDomain', id: string };

export type BeneficiariesReport_Node_WorkflowTracker_Fragment = { __typename: 'WorkflowTracker', id: string };

export type BeneficiariesReport_NodeFragment = BeneficiariesReport_Node_AiSuggestion_Fragment | BeneficiariesReport_Node_AiSuggestionEvidence_Fragment | BeneficiariesReport_Node_AccessAgeParameter_Fragment | BeneficiariesReport_Node_AccessParameter_Fragment | BeneficiariesReport_Node_Account_Fragment | BeneficiariesReport_Node_ActiveEstateInsightsPage_Fragment | BeneficiariesReport_Node_Activity_Fragment | BeneficiariesReport_Node_Address_Fragment | BeneficiariesReport_Node_Answer_Fragment | BeneficiariesReport_Node_AnswerEvidence_Fragment | BeneficiariesReport_Node_AnswerRevision_Fragment | BeneficiariesReport_Node_Approval_Fragment | BeneficiariesReport_Node_AssetClass_Fragment | BeneficiariesReport_Node_AssetGroup_Fragment | BeneficiariesReport_Node_AssetStatic_Fragment | BeneficiariesReport_Node_AssetV2_Fragment | BeneficiariesReport_Node_AssetValuationV2_Fragment | BeneficiariesReport_Node_AssetValueV2_Fragment | BeneficiariesReport_Node_AsyncJob_Fragment | BeneficiariesReport_Node_BalanceSheetBundleConfiguration_Fragment | BeneficiariesReport_Node_BalanceSheetCategory_Fragment | BeneficiariesReport_Node_BalanceSheetViewConfiguration_Fragment | BeneficiariesReport_Node_BeneficiariesBundleConfiguration_Fragment | BeneficiariesReport_Node_BeneficiariesTemplateBundleConfiguration_Fragment | BeneficiariesReport_Node_Beneficiary_Fragment | BeneficiariesReport_Node_BeneficiaryAccessParameter_Fragment | BeneficiariesReport_Node_BeneficiaryDesignationGroup_Fragment | BeneficiariesReport_Node_BeneficiaryDistribution_Fragment | BeneficiariesReport_Node_BeneficiaryDistributionParameter_Fragment | BeneficiariesReport_Node_BeneficiaryPage_Fragment | BeneficiariesReport_Node_BeneficiaryPowerOfAppointment_Fragment | BeneficiariesReport_Node_CCorpBusinessEntity_Fragment | BeneficiariesReport_Node_CltProposal_Fragment | BeneficiariesReport_Node_CltTrust_Fragment | BeneficiariesReport_Node_CrtProposal_Fragment | BeneficiariesReport_Node_CrtTrust_Fragment | BeneficiariesReport_Node_Capability_Fragment | BeneficiariesReport_Node_Cashflow_Fragment | BeneficiariesReport_Node_ClientOrganization_Fragment | BeneficiariesReport_Node_ClientPresentationV2_Fragment | BeneficiariesReport_Node_ClientProfile_Fragment | BeneficiariesReport_Node_ClientProfileRelationship_Fragment | BeneficiariesReport_Node_Collaborator_Fragment | BeneficiariesReport_Node_ComparedWaterfall_Fragment | BeneficiariesReport_Node_CompletedEstateInsightsPage_Fragment | BeneficiariesReport_Node_ControllingParty_Fragment | BeneficiariesReport_Node_Conversation_Fragment | BeneficiariesReport_Node_CoverPageConfiguration_Fragment | BeneficiariesReport_Node_CustodialPersonalAccount_Fragment | BeneficiariesReport_Node_DsuePortability_Fragment | BeneficiariesReport_Node_DiagramArtifact_Fragment | BeneficiariesReport_Node_DiagramArtifactPrompt_Fragment | BeneficiariesReport_Node_DispositionScenario_Fragment | BeneficiariesReport_Node_DispositiveProvision_Fragment | BeneficiariesReport_Node_DispositiveProvisionTemplate_Fragment | BeneficiariesReport_Node_DividerBundleConfiguration_Fragment | BeneficiariesReport_Node_DividerTemplateBundleConfiguration_Fragment | BeneficiariesReport_Node_Document_Fragment | BeneficiariesReport_Node_DocumentQuestion_Fragment | BeneficiariesReport_Node_DocumentQuestionAnswers_Fragment | BeneficiariesReport_Node_DocumentSummary_Fragment | BeneficiariesReport_Node_DocumentSummaryPage_Fragment | BeneficiariesReport_Node_DocumentSummaryPrompt_Fragment | BeneficiariesReport_Node_DocumentSummaryPromptTestRun_Fragment | BeneficiariesReport_Node_DocumentSummaryTemplateBundleConfiguration_Fragment | BeneficiariesReport_Node_DonorAdvisedFund_Fragment | BeneficiariesReport_Node_Employee_Fragment | BeneficiariesReport_Node_EntitiesOverviewBundleConfiguration_Fragment | BeneficiariesReport_Node_EntitiesOverviewBundleConfigurationEntity_Fragment | BeneficiariesReport_Node_Entity_Fragment | BeneficiariesReport_Node_EntityDiagram_Fragment | BeneficiariesReport_Node_EntityDocumentRelationship_Fragment | BeneficiariesReport_Node_EntityGraphView_Fragment | BeneficiariesReport_Node_EntityGraphViewBundleConfiguration_Fragment | BeneficiariesReport_Node_EntityNotes_Fragment | BeneficiariesReport_Node_EntityProposal_Fragment | BeneficiariesReport_Node_EntitySummaryBundleConfiguration_Fragment | BeneficiariesReport_Node_EntitySummaryTemplateBundleConfiguration_Fragment | BeneficiariesReport_Node_EntityTask_Fragment | BeneficiariesReport_Node_EntityTaxInfo_Fragment | BeneficiariesReport_Node_EstateInsight_Fragment | BeneficiariesReport_Node_EstateInsightReference_Fragment | BeneficiariesReport_Node_EstateInsightsBundleConfiguration_Fragment | BeneficiariesReport_Node_EstateTaxScenario_Fragment | BeneficiariesReport_Node_EstateWaterfall_Fragment | BeneficiariesReport_Node_EstateWaterfallHypotheticalStateChange_Fragment | BeneficiariesReport_Node_EstateWaterfallHypotheticalTransfer_Fragment | BeneficiariesReport_Node_EstateWaterfallMessageContext_Fragment | BeneficiariesReport_Node_EstateWaterfallVisualizationConfig_Fragment | BeneficiariesReport_Node_EstateWaterfallVisualizationFilter_Fragment | BeneficiariesReport_Node_FamilyTreeBundleConfiguration_Fragment | BeneficiariesReport_Node_FamilyTreeConfiguration_Fragment | BeneficiariesReport_Node_FeatureFlag_Fragment | BeneficiariesReport_Node_FeatureFlagQueryRule_Fragment | BeneficiariesReport_Node_File_Fragment | BeneficiariesReport_Node_FilePage_Fragment | BeneficiariesReport_Node_FileParagraph_Fragment | BeneficiariesReport_Node_Form_Fragment | BeneficiariesReport_Node_FormVersion_Fragment | BeneficiariesReport_Node_GpBusinessEntity_Fragment | BeneficiariesReport_Node_GratAnnuityV2_Fragment | BeneficiariesReport_Node_GratProposalScenario_Fragment | BeneficiariesReport_Node_GratTrust_Fragment | BeneficiariesReport_Node_GiftingProposal_Fragment | BeneficiariesReport_Node_GiftingProposalCashFlow_Fragment | BeneficiariesReport_Node_GiftingProposalGift_Fragment | BeneficiariesReport_Node_GiftingProposalGiftSender_Fragment | BeneficiariesReport_Node_GiftingProposalPortfolio_Fragment | BeneficiariesReport_Node_GiftingProposalScenario_Fragment | BeneficiariesReport_Node_GraphVisualizationGroup_Fragment | BeneficiariesReport_Node_GrowthProfile_Fragment | BeneficiariesReport_Node_GrowthProfileOverride_Fragment | BeneficiariesReport_Node_Household_Fragment | BeneficiariesReport_Node_HypotheticalClt_Fragment | BeneficiariesReport_Node_HypotheticalCrt_Fragment | BeneficiariesReport_Node_HypotheticalGrat_Fragment | BeneficiariesReport_Node_HypotheticalInsurance_Fragment | BeneficiariesReport_Node_HypotheticalSaleLoan_Fragment | BeneficiariesReport_Node_HypotheticalTransferAsset_Fragment | BeneficiariesReport_Node_HypotheticalTransferFundingSource_Fragment | BeneficiariesReport_Node_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment | BeneficiariesReport_Node_IlitCrummeyLetter_Fragment | BeneficiariesReport_Node_IlitTrust_Fragment | BeneficiariesReport_Node_Image_Fragment | BeneficiariesReport_Node_IncomeTaxPaymentConfig_Fragment | BeneficiariesReport_Node_IndividualPersonalAccount_Fragment | BeneficiariesReport_Node_InferredField_Fragment | BeneficiariesReport_Node_InferredFieldEvidence_Fragment | BeneficiariesReport_Node_InsightsTemplateBundleConfiguration_Fragment | BeneficiariesReport_Node_InsurancePersonalAccount_Fragment | BeneficiariesReport_Node_InsurancePolicy_Fragment | BeneficiariesReport_Node_InsurancePremiumPayment_Fragment | BeneficiariesReport_Node_IntegrationAssetClass_Fragment | BeneficiariesReport_Node_IntegrationCashflow_Fragment | BeneficiariesReport_Node_IntegrationClient_Fragment | BeneficiariesReport_Node_IntegrationConfiguration_Fragment | BeneficiariesReport_Node_IntegrationEntity_Fragment | BeneficiariesReport_Node_IntegrationInsurance_Fragment | BeneficiariesReport_Node_IntegrationLiability_Fragment | BeneficiariesReport_Node_IntegrationPerson_Fragment | BeneficiariesReport_Node_IrrevocableTrust_Fragment | BeneficiariesReport_Node_JointPersonalAccount_Fragment | BeneficiariesReport_Node_KgNode_Fragment | BeneficiariesReport_Node_KgRelationship_Fragment | BeneficiariesReport_Node_KgRoot_Fragment | BeneficiariesReport_Node_Kgv2Document_Fragment | BeneficiariesReport_Node_Kgv2DocumentChange_Fragment | BeneficiariesReport_Node_Kgv2DocumentModification_Fragment | BeneficiariesReport_Node_Kgv2Graph_Fragment | BeneficiariesReport_Node_Kgv2Node_Fragment | BeneficiariesReport_Node_Kgv2NodeAlias_Fragment | BeneficiariesReport_Node_Kgv2NodeEvidence_Fragment | BeneficiariesReport_Node_Kgv2Statement_Fragment | BeneficiariesReport_Node_Kgv2StatementEvidence_Fragment | BeneficiariesReport_Node_Kgv2StatementSupersession_Fragment | BeneficiariesReport_Node_KeyPerson_Fragment | BeneficiariesReport_Node_KeyPersonRole_Fragment | BeneficiariesReport_Node_LlcBusinessEntity_Fragment | BeneficiariesReport_Node_LpBusinessEntity_Fragment | BeneficiariesReport_Node_LiabilitiesBundleConfiguration_Fragment | BeneficiariesReport_Node_Liability_Fragment | BeneficiariesReport_Node_LiabilityPayment_Fragment | BeneficiariesReport_Node_LifeInsuranceBundleConfiguration_Fragment | BeneficiariesReport_Node_LifetimeExclusionEvent_Fragment | BeneficiariesReport_Node_LoggedTransfer_Fragment | BeneficiariesReport_Node_LuminaryOrganization_Fragment | BeneficiariesReport_Node_LuminaryTenantJit_Fragment | BeneficiariesReport_Node_ManagedSftpConnection_Fragment | BeneficiariesReport_Node_Memo_Fragment | BeneficiariesReport_Node_MemoPrompt_Fragment | BeneficiariesReport_Node_Message_Fragment | BeneficiariesReport_Node_MissingDocumentOverride_Fragment | BeneficiariesReport_Node_MissingDocumentsPage_Fragment | BeneficiariesReport_Node_ModelMapping_Fragment | BeneficiariesReport_Node_NotificationApp_Fragment | BeneficiariesReport_Node_NotificationPreference_Fragment | BeneficiariesReport_Node_OpenaiSdkConfig_Fragment | BeneficiariesReport_Node_OrganizationApplicationConfiguration_Fragment | BeneficiariesReport_Node_OrganizationDisclaimerConfiguration_Fragment | BeneficiariesReport_Node_OwnershipStake_Fragment | BeneficiariesReport_Node_PlatformDocument_Fragment | BeneficiariesReport_Node_PlatformFile_Fragment | BeneficiariesReport_Node_PlatformFilePage_Fragment | BeneficiariesReport_Node_PlatformFileParagraph_Fragment | BeneficiariesReport_Node_PresentationApprovalRequest_Fragment | BeneficiariesReport_Node_PresentationAssetDistributionBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationAssetDistributionItemConfiguration_Fragment | BeneficiariesReport_Node_PresentationAssetDistributionItemDetail_Fragment | BeneficiariesReport_Node_PresentationBundle_Fragment | BeneficiariesReport_Node_PresentationBundleCoverPage_Fragment | BeneficiariesReport_Node_PresentationBusinessOverviewBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationBusinessOverviewBusinessConfiguration_Fragment | BeneficiariesReport_Node_PresentationBusinessOverviewItem_Fragment | BeneficiariesReport_Node_PresentationCoverPage_Fragment | BeneficiariesReport_Node_PresentationCoverSlideConfig_Fragment | BeneficiariesReport_Node_PresentationCustomPage_Fragment | BeneficiariesReport_Node_PresentationCustomPageBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationDiagramPage_Fragment | BeneficiariesReport_Node_PresentationDocumentsReviewedBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationDocumentsReviewedDocument_Fragment | BeneficiariesReport_Node_PresentationFamilyOverviewBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationFamilyOverviewMemberConfiguration_Fragment | BeneficiariesReport_Node_PresentationHealthcareDirectiveBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationHealthcareDirectiveClientConfiguration_Fragment | BeneficiariesReport_Node_PresentationHealthcareDirectiveItem_Fragment | BeneficiariesReport_Node_PresentationItemCitation_Fragment | BeneficiariesReport_Node_PresentationPage_Fragment | BeneficiariesReport_Node_PresentationPlanningOpportunitiesBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationPlanningOpportunitiesItem_Fragment | BeneficiariesReport_Node_PresentationPowerOfAttorneyBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationPowerOfAttorneyClientConfiguration_Fragment | BeneficiariesReport_Node_PresentationPowerOfAttorneyItem_Fragment | BeneficiariesReport_Node_PresentationTemplate_Fragment | BeneficiariesReport_Node_PresentationTemplateBundle_Fragment | BeneficiariesReport_Node_PresentationTemplateCoverPage_Fragment | BeneficiariesReport_Node_PresentationTemplateCustomPage_Fragment | BeneficiariesReport_Node_PresentationTemplateDiagramPage_Fragment | BeneficiariesReport_Node_PresentationTemplatePage_Fragment | BeneficiariesReport_Node_PresentationTrustOverviewBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationTrustOverviewItem_Fragment | BeneficiariesReport_Node_PresentationTrustOverviewTrustConfiguration_Fragment | BeneficiariesReport_Node_PresentationWillBundleConfiguration_Fragment | BeneficiariesReport_Node_PresentationWillClientConfiguration_Fragment | BeneficiariesReport_Node_PresentationWillItem_Fragment | BeneficiariesReport_Node_Principal_Fragment | BeneficiariesReport_Node_PrivateFoundation_Fragment | BeneficiariesReport_Node_ProfessionalTeamRole_Fragment | BeneficiariesReport_Node_Proposal_Fragment | BeneficiariesReport_Node_ProposalScenario_Fragment | BeneficiariesReport_Node_QprtTrust_Fragment | BeneficiariesReport_Node_QualifiedTuitionPersonalAccount_Fragment | BeneficiariesReport_Node_ReleaseGroup_Fragment | BeneficiariesReport_Node_ReminderEmailNotificationRecord_Fragment | BeneficiariesReport_Node_RetirementPersonalAccount_Fragment | BeneficiariesReport_Node_RevocableTrust_Fragment | BeneficiariesReport_Node_Role_Fragment | BeneficiariesReport_Node_SCorpBusinessEntity_Fragment | BeneficiariesReport_Node_SlatTrust_Fragment | BeneficiariesReport_Node_SsoConnection_Fragment | BeneficiariesReport_Node_SalesforceExportAttempt_Fragment | BeneficiariesReport_Node_ScheduledDistribution_Fragment | BeneficiariesReport_Node_SoleProprietorshipBusinessEntity_Fragment | BeneficiariesReport_Node_SubBrand_Fragment | BeneficiariesReport_Node_SubBrandDisclaimerConfiguration_Fragment | BeneficiariesReport_Node_Submission_Fragment | BeneficiariesReport_Node_TaxDragConfig_Fragment | BeneficiariesReport_Node_TaxDragOverride_Fragment | BeneficiariesReport_Node_Team_Fragment | BeneficiariesReport_Node_Tenant_Fragment | BeneficiariesReport_Node_TenantApplicationConfiguration_Fragment | BeneficiariesReport_Node_TenantBranding_Fragment | BeneficiariesReport_Node_TenantDisclaimerConfiguration_Fragment | BeneficiariesReport_Node_TenantDocument_Fragment | BeneficiariesReport_Node_TenantReminderEmailsConfiguration_Fragment | BeneficiariesReport_Node_TenantSsoConnection_Fragment | BeneficiariesReport_Node_TenantSecurityConfiguration_Fragment | BeneficiariesReport_Node_TenantSlideConfig_Fragment | BeneficiariesReport_Node_TestCmkEncryption_Fragment | BeneficiariesReport_Node_TestamentaryEntity_Fragment | BeneficiariesReport_Node_TrustAdvisor_Fragment | BeneficiariesReport_Node_TrustAdvisorRole_Fragment | BeneficiariesReport_Node_Trustee_Fragment | BeneficiariesReport_Node_TrusteeDuty_Fragment | BeneficiariesReport_Node_User_Fragment | BeneficiariesReport_Node_UserFeedback_Fragment | BeneficiariesReport_Node_UserNotificationConfiguration_Fragment | BeneficiariesReport_Node_WaterfallBundleConfiguration_Fragment | BeneficiariesReport_Node_WaterfallBundleCoverPage_Fragment | BeneficiariesReport_Node_WaterfallComparisonBundleConfiguration_Fragment | BeneficiariesReport_Node_WaterfallComparisonTemplateBundleConfiguration_Fragment | BeneficiariesReport_Node_WaterfallTemplateBundleConfiguration_Fragment | BeneficiariesReport_Node_WorkOsOrganization_Fragment | BeneficiariesReport_Node_WorkOsOrganizationDomain_Fragment | BeneficiariesReport_Node_WorkflowTracker_Fragment;

export type BeneficiariesReport_AccessAgeParameterViewFragment = { __typename?: 'AccessAgeParameterView', ageEnd?: number | null, ageStart?: number | null };

export type BeneficiaiesReport_PercentageAccessParameterViewFragment = { __typename?: 'PercentageAccessParameterView', kind: Types.AccessParameterKind, frequency?: Types.AccessParameterFrequency | null, accessPercentage: Percent, accessAgeParameters: Array<(
    { __typename?: 'AccessAgeParameterView' }
    & BeneficiariesReport_AccessAgeParameterViewFragment
  )> };

export type BeneficiariesReport_AmountAccessParameterViewFragment = { __typename?: 'AmountAccessParameterView', kind: Types.AccessParameterKind, frequency?: Types.AccessParameterFrequency | null, accessAmount: CurrencyUSD, accessAgeParameters: Array<(
    { __typename?: 'AccessAgeParameterView' }
    & BeneficiariesReport_AccessAgeParameterViewFragment
  )> };

export type BeneficiariesReport_TrustIncomeAccessParameterViewFragment = { __typename?: 'TrustIncomeAccessParameterView', kind: Types.AccessParameterKind, amount?: CurrencyUSD | null, frequency?: Types.AccessParameterFrequency | null, percentage?: Percent | null, accessAgeParameters: Array<(
    { __typename?: 'AccessAgeParameterView' }
    & BeneficiariesReport_AccessAgeParameterViewFragment
  )> };

export type BeneficiariesReport_DiscretionaryAccessParameterViewFragment = { __typename?: 'DiscretionaryAccessParameterView', kind: Types.AccessParameterKind, accessAgeParameters: Array<(
    { __typename?: 'AccessAgeParameterView' }
    & BeneficiariesReport_AccessAgeParameterViewFragment
  )> };

export type BeneficiariesReport_BeneficiaryReportEntityBreakdownFragment = { __typename?: 'BeneficiaryReportEntityBreakdown', _cacheKey: string, accessSource: Types.BeneficiaryReportAccessSource, accessDetails: string, accessDetailsSubtext?: string | null, beneficialAmount: CurrencyUSD, distributionFrequency?: Types.BeneficiaryDistributionDistributionFrequency | null, displayName: string, id: string, entityValue: CurrencyUSD, notes?: string | null, node: (
    { __typename?: 'AISuggestion' }
    & BeneficiariesReport_Node_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence' }
    & BeneficiariesReport_Node_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter' }
    & BeneficiariesReport_Node_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter' }
    & BeneficiariesReport_Node_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account' }
    & BeneficiariesReport_Node_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage' }
    & BeneficiariesReport_Node_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity' }
    & BeneficiariesReport_Node_Activity_Fragment
  ) | (
    { __typename?: 'Address' }
    & BeneficiariesReport_Node_Address_Fragment
  ) | (
    { __typename?: 'Answer' }
    & BeneficiariesReport_Node_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence' }
    & BeneficiariesReport_Node_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision' }
    & BeneficiariesReport_Node_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval' }
    & BeneficiariesReport_Node_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass' }
    & BeneficiariesReport_Node_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup' }
    & BeneficiariesReport_Node_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic' }
    & BeneficiariesReport_Node_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2' }
    & BeneficiariesReport_Node_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2' }
    & BeneficiariesReport_Node_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2' }
    & BeneficiariesReport_Node_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob' }
    & BeneficiariesReport_Node_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & BeneficiariesReport_Node_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory' }
    & BeneficiariesReport_Node_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration' }
    & BeneficiariesReport_Node_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & BeneficiariesReport_Node_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
    & BeneficiariesReport_Node_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary' }
    & BeneficiariesReport_Node_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter' }
    & BeneficiariesReport_Node_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & BeneficiariesReport_Node_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution' }
    & BeneficiariesReport_Node_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter' }
    & BeneficiariesReport_Node_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage' }
    & BeneficiariesReport_Node_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment' }
    & BeneficiariesReport_Node_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity' }
    & BeneficiariesReport_Node_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal' }
    & BeneficiariesReport_Node_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust' }
    & BeneficiariesReport_Node_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal' }
    & BeneficiariesReport_Node_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust' }
    & BeneficiariesReport_Node_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability' }
    & BeneficiariesReport_Node_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow' }
    & BeneficiariesReport_Node_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization' }
    & BeneficiariesReport_Node_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2' }
    & BeneficiariesReport_Node_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile' }
    & BeneficiariesReport_Node_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship' }
    & BeneficiariesReport_Node_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator' }
    & BeneficiariesReport_Node_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall' }
    & BeneficiariesReport_Node_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage' }
    & BeneficiariesReport_Node_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty' }
    & BeneficiariesReport_Node_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation' }
    & BeneficiariesReport_Node_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration' }
    & BeneficiariesReport_Node_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & BeneficiariesReport_Node_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability' }
    & BeneficiariesReport_Node_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact' }
    & BeneficiariesReport_Node_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt' }
    & BeneficiariesReport_Node_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario' }
    & BeneficiariesReport_Node_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision' }
    & BeneficiariesReport_Node_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate' }
    & BeneficiariesReport_Node_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration' }
    & BeneficiariesReport_Node_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration' }
    & BeneficiariesReport_Node_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document' }
    & BeneficiariesReport_Node_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion' }
    & BeneficiariesReport_Node_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers' }
    & BeneficiariesReport_Node_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary' }
    & BeneficiariesReport_Node_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage' }
    & BeneficiariesReport_Node_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt' }
    & BeneficiariesReport_Node_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun' }
    & BeneficiariesReport_Node_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
    & BeneficiariesReport_Node_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & BeneficiariesReport_Node_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee' }
    & BeneficiariesReport_Node_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & BeneficiariesReport_Node_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
    & BeneficiariesReport_Node_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity' }
    & BeneficiariesReport_Node_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram' }
    & BeneficiariesReport_Node_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship' }
    & BeneficiariesReport_Node_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView' }
    & BeneficiariesReport_Node_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & BeneficiariesReport_Node_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes' }
    & BeneficiariesReport_Node_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal' }
    & BeneficiariesReport_Node_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & BeneficiariesReport_Node_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
    & BeneficiariesReport_Node_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask' }
    & BeneficiariesReport_Node_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo' }
    & BeneficiariesReport_Node_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight' }
    & BeneficiariesReport_Node_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference' }
    & BeneficiariesReport_Node_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & BeneficiariesReport_Node_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario' }
    & BeneficiariesReport_Node_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall' }
    & BeneficiariesReport_Node_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange' }
    & BeneficiariesReport_Node_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer' }
    & BeneficiariesReport_Node_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext' }
    & BeneficiariesReport_Node_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & BeneficiariesReport_Node_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter' }
    & BeneficiariesReport_Node_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration' }
    & BeneficiariesReport_Node_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration' }
    & BeneficiariesReport_Node_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag' }
    & BeneficiariesReport_Node_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule' }
    & BeneficiariesReport_Node_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File' }
    & BeneficiariesReport_Node_File_Fragment
  ) | (
    { __typename?: 'FilePage' }
    & BeneficiariesReport_Node_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph' }
    & BeneficiariesReport_Node_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form' }
    & BeneficiariesReport_Node_Form_Fragment
  ) | (
    { __typename?: 'FormVersion' }
    & BeneficiariesReport_Node_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity' }
    & BeneficiariesReport_Node_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2' }
    & BeneficiariesReport_Node_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario' }
    & BeneficiariesReport_Node_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust' }
    & BeneficiariesReport_Node_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal' }
    & BeneficiariesReport_Node_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow' }
    & BeneficiariesReport_Node_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift' }
    & BeneficiariesReport_Node_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender' }
    & BeneficiariesReport_Node_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio' }
    & BeneficiariesReport_Node_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario' }
    & BeneficiariesReport_Node_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup' }
    & BeneficiariesReport_Node_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile' }
    & BeneficiariesReport_Node_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride' }
    & BeneficiariesReport_Node_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household' }
    & BeneficiariesReport_Node_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT' }
    & BeneficiariesReport_Node_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT' }
    & BeneficiariesReport_Node_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT' }
    & BeneficiariesReport_Node_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance' }
    & BeneficiariesReport_Node_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan' }
    & BeneficiariesReport_Node_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset' }
    & BeneficiariesReport_Node_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & BeneficiariesReport_Node_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
    & BeneficiariesReport_Node_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter' }
    & BeneficiariesReport_Node_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust' }
    & BeneficiariesReport_Node_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image' }
    & BeneficiariesReport_Node_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig' }
    & BeneficiariesReport_Node_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & BeneficiariesReport_Node_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField' }
    & BeneficiariesReport_Node_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence' }
    & BeneficiariesReport_Node_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration' }
    & BeneficiariesReport_Node_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & BeneficiariesReport_Node_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy' }
    & BeneficiariesReport_Node_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment' }
    & BeneficiariesReport_Node_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass' }
    & BeneficiariesReport_Node_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow' }
    & BeneficiariesReport_Node_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient' }
    & BeneficiariesReport_Node_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration' }
    & BeneficiariesReport_Node_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity' }
    & BeneficiariesReport_Node_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance' }
    & BeneficiariesReport_Node_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability' }
    & BeneficiariesReport_Node_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson' }
    & BeneficiariesReport_Node_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & BeneficiariesReport_Node_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & BeneficiariesReport_Node_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode' }
    & BeneficiariesReport_Node_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship' }
    & BeneficiariesReport_Node_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot' }
    & BeneficiariesReport_Node_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document' }
    & BeneficiariesReport_Node_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange' }
    & BeneficiariesReport_Node_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification' }
    & BeneficiariesReport_Node_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph' }
    & BeneficiariesReport_Node_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node' }
    & BeneficiariesReport_Node_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias' }
    & BeneficiariesReport_Node_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence' }
    & BeneficiariesReport_Node_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement' }
    & BeneficiariesReport_Node_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence' }
    & BeneficiariesReport_Node_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession' }
    & BeneficiariesReport_Node_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson' }
    & BeneficiariesReport_Node_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole' }
    & BeneficiariesReport_Node_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity' }
    & BeneficiariesReport_Node_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity' }
    & BeneficiariesReport_Node_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration' }
    & BeneficiariesReport_Node_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability' }
    & BeneficiariesReport_Node_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment' }
    & BeneficiariesReport_Node_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration' }
    & BeneficiariesReport_Node_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent' }
    & BeneficiariesReport_Node_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer' }
    & BeneficiariesReport_Node_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization' }
    & BeneficiariesReport_Node_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT' }
    & BeneficiariesReport_Node_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection' }
    & BeneficiariesReport_Node_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo' }
    & BeneficiariesReport_Node_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt' }
    & BeneficiariesReport_Node_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message' }
    & BeneficiariesReport_Node_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride' }
    & BeneficiariesReport_Node_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage' }
    & BeneficiariesReport_Node_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping' }
    & BeneficiariesReport_Node_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp' }
    & BeneficiariesReport_Node_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference' }
    & BeneficiariesReport_Node_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig' }
    & BeneficiariesReport_Node_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & BeneficiariesReport_Node_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & BeneficiariesReport_Node_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake' }
    & BeneficiariesReport_Node_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument' }
    & BeneficiariesReport_Node_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile' }
    & BeneficiariesReport_Node_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage' }
    & BeneficiariesReport_Node_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph' }
    & BeneficiariesReport_Node_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest' }
    & BeneficiariesReport_Node_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration' }
    & BeneficiariesReport_Node_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail' }
    & BeneficiariesReport_Node_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle' }
    & BeneficiariesReport_Node_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage' }
    & BeneficiariesReport_Node_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
    & BeneficiariesReport_Node_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem' }
    & BeneficiariesReport_Node_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage' }
    & BeneficiariesReport_Node_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig' }
    & BeneficiariesReport_Node_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage' }
    & BeneficiariesReport_Node_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage' }
    & BeneficiariesReport_Node_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument' }
    & BeneficiariesReport_Node_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
    & BeneficiariesReport_Node_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
    & BeneficiariesReport_Node_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem' }
    & BeneficiariesReport_Node_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation' }
    & BeneficiariesReport_Node_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage' }
    & BeneficiariesReport_Node_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem' }
    & BeneficiariesReport_Node_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
    & BeneficiariesReport_Node_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem' }
    & BeneficiariesReport_Node_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate' }
    & BeneficiariesReport_Node_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle' }
    & BeneficiariesReport_Node_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage' }
    & BeneficiariesReport_Node_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage' }
    & BeneficiariesReport_Node_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage' }
    & BeneficiariesReport_Node_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage' }
    & BeneficiariesReport_Node_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem' }
    & BeneficiariesReport_Node_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
    & BeneficiariesReport_Node_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & BeneficiariesReport_Node_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration' }
    & BeneficiariesReport_Node_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem' }
    & BeneficiariesReport_Node_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal' }
    & BeneficiariesReport_Node_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation' }
    & BeneficiariesReport_Node_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole' }
    & BeneficiariesReport_Node_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal' }
    & BeneficiariesReport_Node_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario' }
    & BeneficiariesReport_Node_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & BeneficiariesReport_Node_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & BeneficiariesReport_Node_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup' }
    & BeneficiariesReport_Node_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord' }
    & BeneficiariesReport_Node_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & BeneficiariesReport_Node_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & BeneficiariesReport_Node_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role' }
    & BeneficiariesReport_Node_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity' }
    & BeneficiariesReport_Node_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust' }
    & BeneficiariesReport_Node_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection' }
    & BeneficiariesReport_Node_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt' }
    & BeneficiariesReport_Node_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution' }
    & BeneficiariesReport_Node_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity' }
    & BeneficiariesReport_Node_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand' }
    & BeneficiariesReport_Node_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & BeneficiariesReport_Node_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission' }
    & BeneficiariesReport_Node_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig' }
    & BeneficiariesReport_Node_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride' }
    & BeneficiariesReport_Node_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team' }
    & BeneficiariesReport_Node_Team_Fragment
  ) | (
    { __typename?: 'Tenant' }
    & BeneficiariesReport_Node_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration' }
    & BeneficiariesReport_Node_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding' }
    & BeneficiariesReport_Node_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration' }
    & BeneficiariesReport_Node_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument' }
    & BeneficiariesReport_Node_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration' }
    & BeneficiariesReport_Node_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection' }
    & BeneficiariesReport_Node_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration' }
    & BeneficiariesReport_Node_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig' }
    & BeneficiariesReport_Node_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption' }
    & BeneficiariesReport_Node_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity' }
    & BeneficiariesReport_Node_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor' }
    & BeneficiariesReport_Node_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole' }
    & BeneficiariesReport_Node_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee' }
    & BeneficiariesReport_Node_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty' }
    & BeneficiariesReport_Node_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User' }
    & BeneficiariesReport_Node_User_Fragment
  ) | (
    { __typename?: 'UserFeedback' }
    & BeneficiariesReport_Node_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration' }
    & BeneficiariesReport_Node_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration' }
    & BeneficiariesReport_Node_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage' }
    & BeneficiariesReport_Node_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & BeneficiariesReport_Node_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
    & BeneficiariesReport_Node_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration' }
    & BeneficiariesReport_Node_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization' }
    & BeneficiariesReport_Node_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain' }
    & BeneficiariesReport_Node_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker' }
    & BeneficiariesReport_Node_WorkflowTracker_Fragment
  ), associatedObject?: (
    { __typename?: 'AISuggestion', id: string }
    & BeneficiariesReport_Node_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence', id: string }
    & BeneficiariesReport_Node_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter', id: string }
    & BeneficiariesReport_Node_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter', id: string }
    & BeneficiariesReport_Node_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account', id: string }
    & BeneficiariesReport_Node_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage', id: string }
    & BeneficiariesReport_Node_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity', id: string }
    & BeneficiariesReport_Node_Activity_Fragment
  ) | (
    { __typename?: 'Address', id: string }
    & BeneficiariesReport_Node_Address_Fragment
  ) | (
    { __typename?: 'Answer', id: string }
    & BeneficiariesReport_Node_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence', id: string }
    & BeneficiariesReport_Node_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision', id: string }
    & BeneficiariesReport_Node_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval', id: string }
    & BeneficiariesReport_Node_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass', id: string }
    & BeneficiariesReport_Node_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup', id: string }
    & BeneficiariesReport_Node_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic', id: string }
    & BeneficiariesReport_Node_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2', id: string }
    & BeneficiariesReport_Node_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2', id: string }
    & BeneficiariesReport_Node_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2', id: string }
    & BeneficiariesReport_Node_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob', id: string }
    & BeneficiariesReport_Node_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration', id: string }
    & BeneficiariesReport_Node_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory', id: string }
    & BeneficiariesReport_Node_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration', id: string }
    & BeneficiariesReport_Node_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration', id: string }
    & BeneficiariesReport_Node_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration', id: string }
    & BeneficiariesReport_Node_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary', id: string }
    & BeneficiariesReport_Node_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter', id: string }
    & BeneficiariesReport_Node_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup', id: string }
    & BeneficiariesReport_Node_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution', id: string }
    & BeneficiariesReport_Node_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter', id: string }
    & BeneficiariesReport_Node_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage', id: string }
    & BeneficiariesReport_Node_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment', id: string }
    & BeneficiariesReport_Node_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity', id: string }
    & BeneficiariesReport_Node_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal', id: string }
    & BeneficiariesReport_Node_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust', id: string }
    & BeneficiariesReport_Node_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal', id: string }
    & BeneficiariesReport_Node_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust', id: string }
    & BeneficiariesReport_Node_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability', id: string }
    & BeneficiariesReport_Node_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow', id: string }
    & BeneficiariesReport_Node_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization', id: string }
    & BeneficiariesReport_Node_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2', id: string }
    & BeneficiariesReport_Node_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile', id: string }
    & BeneficiariesReport_Node_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship', id: string }
    & BeneficiariesReport_Node_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator', id: string }
    & BeneficiariesReport_Node_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall', id: string }
    & BeneficiariesReport_Node_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage', id: string }
    & BeneficiariesReport_Node_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty', id: string }
    & BeneficiariesReport_Node_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation', id: string }
    & BeneficiariesReport_Node_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration', id: string }
    & BeneficiariesReport_Node_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount', id: string }
    & BeneficiariesReport_Node_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability', id: string }
    & BeneficiariesReport_Node_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact', id: string }
    & BeneficiariesReport_Node_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt', id: string }
    & BeneficiariesReport_Node_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario', id: string }
    & BeneficiariesReport_Node_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision', id: string }
    & BeneficiariesReport_Node_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate', id: string }
    & BeneficiariesReport_Node_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration', id: string }
    & BeneficiariesReport_Node_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration', id: string }
    & BeneficiariesReport_Node_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document', id: string }
    & BeneficiariesReport_Node_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion', id: string }
    & BeneficiariesReport_Node_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers', id: string }
    & BeneficiariesReport_Node_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary', id: string }
    & BeneficiariesReport_Node_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage', id: string }
    & BeneficiariesReport_Node_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt', id: string }
    & BeneficiariesReport_Node_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun', id: string }
    & BeneficiariesReport_Node_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration', id: string }
    & BeneficiariesReport_Node_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund', id: string }
    & BeneficiariesReport_Node_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee', id: string }
    & BeneficiariesReport_Node_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration', id: string }
    & BeneficiariesReport_Node_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity', id: string }
    & BeneficiariesReport_Node_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity', id: string }
    & BeneficiariesReport_Node_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram', id: string }
    & BeneficiariesReport_Node_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship', id: string }
    & BeneficiariesReport_Node_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView', id: string }
    & BeneficiariesReport_Node_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration', id: string }
    & BeneficiariesReport_Node_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes', id: string }
    & BeneficiariesReport_Node_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal', id: string }
    & BeneficiariesReport_Node_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration', id: string }
    & BeneficiariesReport_Node_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration', id: string }
    & BeneficiariesReport_Node_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask', id: string }
    & BeneficiariesReport_Node_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo', id: string }
    & BeneficiariesReport_Node_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight', id: string }
    & BeneficiariesReport_Node_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference', id: string }
    & BeneficiariesReport_Node_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration', id: string }
    & BeneficiariesReport_Node_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario', id: string }
    & BeneficiariesReport_Node_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall', id: string }
    & BeneficiariesReport_Node_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange', id: string }
    & BeneficiariesReport_Node_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string }
    & BeneficiariesReport_Node_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext', id: string }
    & BeneficiariesReport_Node_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig', id: string }
    & BeneficiariesReport_Node_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter', id: string }
    & BeneficiariesReport_Node_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration', id: string }
    & BeneficiariesReport_Node_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration', id: string }
    & BeneficiariesReport_Node_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag', id: string }
    & BeneficiariesReport_Node_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule', id: string }
    & BeneficiariesReport_Node_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File', id: string }
    & BeneficiariesReport_Node_File_Fragment
  ) | (
    { __typename?: 'FilePage', id: string }
    & BeneficiariesReport_Node_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph', id: string }
    & BeneficiariesReport_Node_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form', id: string }
    & BeneficiariesReport_Node_Form_Fragment
  ) | (
    { __typename?: 'FormVersion', id: string }
    & BeneficiariesReport_Node_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity', id: string }
    & BeneficiariesReport_Node_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2', id: string }
    & BeneficiariesReport_Node_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario', id: string }
    & BeneficiariesReport_Node_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust', id: string }
    & BeneficiariesReport_Node_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal', id: string }
    & BeneficiariesReport_Node_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow', id: string }
    & BeneficiariesReport_Node_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift', id: string }
    & BeneficiariesReport_Node_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender', id: string }
    & BeneficiariesReport_Node_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio', id: string }
    & BeneficiariesReport_Node_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario', id: string }
    & BeneficiariesReport_Node_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup', id: string }
    & BeneficiariesReport_Node_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile', id: string }
    & BeneficiariesReport_Node_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride', id: string }
    & BeneficiariesReport_Node_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household', id: string }
    & BeneficiariesReport_Node_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT', id: string }
    & BeneficiariesReport_Node_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT', id: string }
    & BeneficiariesReport_Node_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT', id: string }
    & BeneficiariesReport_Node_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance', id: string }
    & BeneficiariesReport_Node_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan', id: string }
    & BeneficiariesReport_Node_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset', id: string }
    & BeneficiariesReport_Node_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource', id: string }
    & BeneficiariesReport_Node_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate', id: string }
    & BeneficiariesReport_Node_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter', id: string }
    & BeneficiariesReport_Node_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust', id: string }
    & BeneficiariesReport_Node_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image', id: string }
    & BeneficiariesReport_Node_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig', id: string }
    & BeneficiariesReport_Node_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount', id: string }
    & BeneficiariesReport_Node_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField', id: string }
    & BeneficiariesReport_Node_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence', id: string }
    & BeneficiariesReport_Node_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration', id: string }
    & BeneficiariesReport_Node_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount', id: string }
    & BeneficiariesReport_Node_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy', id: string }
    & BeneficiariesReport_Node_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment', id: string }
    & BeneficiariesReport_Node_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass', id: string }
    & BeneficiariesReport_Node_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow', id: string }
    & BeneficiariesReport_Node_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient', id: string }
    & BeneficiariesReport_Node_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration', id: string }
    & BeneficiariesReport_Node_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity', id: string }
    & BeneficiariesReport_Node_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance', id: string }
    & BeneficiariesReport_Node_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability', id: string }
    & BeneficiariesReport_Node_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson', id: string }
    & BeneficiariesReport_Node_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust', id: string }
    & BeneficiariesReport_Node_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount', id: string }
    & BeneficiariesReport_Node_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode', id: string }
    & BeneficiariesReport_Node_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship', id: string }
    & BeneficiariesReport_Node_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot', id: string }
    & BeneficiariesReport_Node_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document', id: string }
    & BeneficiariesReport_Node_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange', id: string }
    & BeneficiariesReport_Node_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification', id: string }
    & BeneficiariesReport_Node_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph', id: string }
    & BeneficiariesReport_Node_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node', id: string }
    & BeneficiariesReport_Node_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias', id: string }
    & BeneficiariesReport_Node_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence', id: string }
    & BeneficiariesReport_Node_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement', id: string }
    & BeneficiariesReport_Node_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence', id: string }
    & BeneficiariesReport_Node_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession', id: string }
    & BeneficiariesReport_Node_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson', id: string }
    & BeneficiariesReport_Node_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole', id: string }
    & BeneficiariesReport_Node_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity', id: string }
    & BeneficiariesReport_Node_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity', id: string }
    & BeneficiariesReport_Node_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration', id: string }
    & BeneficiariesReport_Node_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability', id: string }
    & BeneficiariesReport_Node_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment', id: string }
    & BeneficiariesReport_Node_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration', id: string }
    & BeneficiariesReport_Node_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent', id: string }
    & BeneficiariesReport_Node_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer', id: string }
    & BeneficiariesReport_Node_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization', id: string }
    & BeneficiariesReport_Node_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT', id: string }
    & BeneficiariesReport_Node_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection', id: string }
    & BeneficiariesReport_Node_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo', id: string }
    & BeneficiariesReport_Node_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt', id: string }
    & BeneficiariesReport_Node_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message', id: string }
    & BeneficiariesReport_Node_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride', id: string }
    & BeneficiariesReport_Node_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage', id: string }
    & BeneficiariesReport_Node_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping', id: string }
    & BeneficiariesReport_Node_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp', id: string }
    & BeneficiariesReport_Node_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference', id: string }
    & BeneficiariesReport_Node_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig', id: string }
    & BeneficiariesReport_Node_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration', id: string }
    & BeneficiariesReport_Node_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration', id: string }
    & BeneficiariesReport_Node_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake', id: string }
    & BeneficiariesReport_Node_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument', id: string }
    & BeneficiariesReport_Node_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile', id: string }
    & BeneficiariesReport_Node_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage', id: string }
    & BeneficiariesReport_Node_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph', id: string }
    & BeneficiariesReport_Node_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest', id: string }
    & BeneficiariesReport_Node_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail', id: string }
    & BeneficiariesReport_Node_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle', id: string }
    & BeneficiariesReport_Node_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage', id: string }
    & BeneficiariesReport_Node_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem', id: string }
    & BeneficiariesReport_Node_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage', id: string }
    & BeneficiariesReport_Node_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig', id: string }
    & BeneficiariesReport_Node_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage', id: string }
    & BeneficiariesReport_Node_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage', id: string }
    & BeneficiariesReport_Node_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument', id: string }
    & BeneficiariesReport_Node_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem', id: string }
    & BeneficiariesReport_Node_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation', id: string }
    & BeneficiariesReport_Node_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage', id: string }
    & BeneficiariesReport_Node_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem', id: string }
    & BeneficiariesReport_Node_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem', id: string }
    & BeneficiariesReport_Node_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate', id: string }
    & BeneficiariesReport_Node_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle', id: string }
    & BeneficiariesReport_Node_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage', id: string }
    & BeneficiariesReport_Node_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage', id: string }
    & BeneficiariesReport_Node_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage', id: string }
    & BeneficiariesReport_Node_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage', id: string }
    & BeneficiariesReport_Node_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem', id: string }
    & BeneficiariesReport_Node_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration', id: string }
    & BeneficiariesReport_Node_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem', id: string }
    & BeneficiariesReport_Node_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal', id: string }
    & BeneficiariesReport_Node_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation', id: string }
    & BeneficiariesReport_Node_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole', id: string }
    & BeneficiariesReport_Node_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal', id: string }
    & BeneficiariesReport_Node_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario', id: string }
    & BeneficiariesReport_Node_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust', id: string }
    & BeneficiariesReport_Node_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount', id: string }
    & BeneficiariesReport_Node_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup', id: string }
    & BeneficiariesReport_Node_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord', id: string }
    & BeneficiariesReport_Node_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount', id: string }
    & BeneficiariesReport_Node_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust', id: string }
    & BeneficiariesReport_Node_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role', id: string }
    & BeneficiariesReport_Node_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity', id: string }
    & BeneficiariesReport_Node_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust', id: string }
    & BeneficiariesReport_Node_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection', id: string }
    & BeneficiariesReport_Node_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt', id: string }
    & BeneficiariesReport_Node_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution', id: string }
    & BeneficiariesReport_Node_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity', id: string }
    & BeneficiariesReport_Node_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand', id: string }
    & BeneficiariesReport_Node_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration', id: string }
    & BeneficiariesReport_Node_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission', id: string }
    & BeneficiariesReport_Node_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig', id: string }
    & BeneficiariesReport_Node_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride', id: string }
    & BeneficiariesReport_Node_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team', id: string }
    & BeneficiariesReport_Node_Team_Fragment
  ) | (
    { __typename?: 'Tenant', id: string }
    & BeneficiariesReport_Node_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration', id: string }
    & BeneficiariesReport_Node_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding', id: string }
    & BeneficiariesReport_Node_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration', id: string }
    & BeneficiariesReport_Node_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument', id: string }
    & BeneficiariesReport_Node_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration', id: string }
    & BeneficiariesReport_Node_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection', id: string }
    & BeneficiariesReport_Node_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration', id: string }
    & BeneficiariesReport_Node_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig', id: string }
    & BeneficiariesReport_Node_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption', id: string }
    & BeneficiariesReport_Node_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity', id: string }
    & BeneficiariesReport_Node_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor', id: string }
    & BeneficiariesReport_Node_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole', id: string }
    & BeneficiariesReport_Node_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee', id: string }
    & BeneficiariesReport_Node_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty', id: string }
    & BeneficiariesReport_Node_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User', id: string }
    & BeneficiariesReport_Node_User_Fragment
  ) | (
    { __typename?: 'UserFeedback', id: string }
    & BeneficiariesReport_Node_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration', id: string }
    & BeneficiariesReport_Node_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration', id: string }
    & BeneficiariesReport_Node_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage', id: string }
    & BeneficiariesReport_Node_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration', id: string }
    & BeneficiariesReport_Node_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration', id: string }
    & BeneficiariesReport_Node_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration', id: string }
    & BeneficiariesReport_Node_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization', id: string }
    & BeneficiariesReport_Node_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain', id: string }
    & BeneficiariesReport_Node_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker', id: string }
    & BeneficiariesReport_Node_WorkflowTracker_Fragment
  ) | null, powerOfAppointment?: { __typename?: 'BeneficiaryPowerOfAppointment', id: string, power?: Types.BeneficiaryPowerOfAppointmentPower | null } | null, accessParametersResolved: Array<(
    { __typename?: 'AmountAccessParameterView' }
    & BeneficiariesReport_AmountAccessParameterViewFragment
  ) | (
    { __typename?: 'DiscretionaryAccessParameterView' }
    & BeneficiariesReport_DiscretionaryAccessParameterViewFragment
  ) | (
    { __typename?: 'PercentageAccessParameterView' }
    & BeneficiaiesReport_PercentageAccessParameterViewFragment
  ) | (
    { __typename?: 'TrustIncomeAccessParameterView' }
    & BeneficiariesReport_TrustIncomeAccessParameterViewFragment
  )>, scheduledDistribution?: { __typename?: 'ScheduledDistribution', id: string, ageRequirementStart?: number | null, ageRequirementEnd?: number | null } | null, dispositiveProvision?: { __typename?: 'DispositiveProvision', id: string } | null };

export type BeneficiariesReport_BeneficiaryReportAccessBreakdownFragment = { __typename?: 'BeneficiaryReportAccessBreakdown', _cacheKey: string, entities?: Array<(
    { __typename?: 'BeneficiaryReportEntityBreakdown' }
    & BeneficiariesReport_BeneficiaryReportEntityBreakdownFragment
  )> | null };

export type BeneficiariesReport_BeneficiaryReportFutureAccessBreakdownFragment = { __typename?: 'BeneficiaryReportFutureAccess', _cacheKey: string, milestones: Array<string>, year: number, breakdown: (
    { __typename?: 'BeneficiaryReportAccessBreakdown' }
    & BeneficiariesReport_BeneficiaryReportAccessBreakdownFragment
  ) };

export type BeneficiariesReport_BeneficiaryReportBeneficiaryBreakdownFragment = { __typename?: 'BeneficiaryReportBeneficiaryBreakdown', _cacheKey: string, calculationMethod?: Types.BeneficiaryReportAccessCalculationMethod | null, currentAccessAmount: CurrencyUSD, futureAccessAmount: CurrencyUSD, futureDistributions: CurrencyUSD, beneficiaryAge?: number | null, pastDistributionAmount?: CurrencyUSD | null, currentAccessBreakdown: (
    { __typename?: 'BeneficiaryReportAccessBreakdown' }
    & BeneficiariesReport_BeneficiaryReportAccessBreakdownFragment
  ), futureAccessBreakdown?: Array<(
    { __typename?: 'BeneficiaryReportFutureAccess' }
    & BeneficiariesReport_BeneficiaryReportFutureAccessBreakdownFragment
  )> | null, beneficiary?: (
    { __typename?: 'ClientProfile' }
    & BeneficiariesReport_ClientProfileFragment
  ) | null, orgBeneficiary?: { __typename?: 'ClientOrganization', id: string, name: string } | null, yearByYearAccess?: Array<(
    { __typename?: 'BeneficiaryReportYearByYearBeneficiaryAccess' }
    & BeneficiariesReport_BeneficiaryReportYearByYearBeneficiaryAccessFragment
  )> | null };

export type BeneficiariesReport_EstateWaterfallMaterializedInputParamsFragment = { __typename?: 'EstateWaterfallMaterializedInputParams', firstGrantorDeathYear: number, secondGrantorDeathYear?: number | null, selectedGrowthProfile?: { __typename?: 'GrowthProfile', id: string, displayName: string } | null };

export type BeneficiariesReportQueryVariables = Types.Exact<{
  waterfallId: Types.Scalars['ID']['input'];
  householdId: Types.Scalars['ID']['input'];
}>;


export type BeneficiariesReportQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall' }
        & BeneficiariesReport_EstateWaterfallFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    BeneficiariesReport: 'BeneficiariesReport' as const
  },
  Fragment: {
    BeneficiariesReport_EstateWaterfall: 'BeneficiariesReport_EstateWaterfall' as const,
    BeneficiariesReport_EstateWaterfallBeneficiaryReport: 'BeneficiariesReport_EstateWaterfallBeneficiaryReport' as const,
    BeneficiariesReport_ClientProfile: 'BeneficiariesReport_ClientProfile' as const,
    BeneficiariesReport_BeneficiaryReportYearByYearBeneficiaryAccess: 'BeneficiariesReport_BeneficiaryReportYearByYearBeneficiaryAccess' as const,
    BeneficiariesReport_Node: 'BeneficiariesReport_Node' as const,
    BeneficiariesReport_AccessAgeParameterView: 'BeneficiariesReport_AccessAgeParameterView' as const,
    BeneficiaiesReport_PercentageAccessParameterView: 'BeneficiaiesReport_PercentageAccessParameterView' as const,
    BeneficiariesReport_AmountAccessParameterView: 'BeneficiariesReport_AmountAccessParameterView' as const,
    BeneficiariesReport_TrustIncomeAccessParameterView: 'BeneficiariesReport_TrustIncomeAccessParameterView' as const,
    BeneficiariesReport_DiscretionaryAccessParameterView: 'BeneficiariesReport_DiscretionaryAccessParameterView' as const,
    BeneficiariesReport_BeneficiaryReportEntityBreakdown: 'BeneficiariesReport_BeneficiaryReportEntityBreakdown' as const,
    BeneficiariesReport_BeneficiaryReportAccessBreakdown: 'BeneficiariesReport_BeneficiaryReportAccessBreakdown' as const,
    BeneficiariesReport_BeneficiaryReportFutureAccessBreakdown: 'BeneficiariesReport_BeneficiaryReportFutureAccessBreakdown' as const,
    BeneficiariesReport_BeneficiaryReportBeneficiaryBreakdown: 'BeneficiariesReport_BeneficiaryReportBeneficiaryBreakdown' as const,
    BeneficiariesReport_EstateWaterfallMaterializedInputParams: 'BeneficiariesReport_EstateWaterfallMaterializedInputParams' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const BeneficiariesReport_ClientProfileFragmentDoc = gql`
    fragment BeneficiariesReport_ClientProfile on ClientProfile {
  id
  displayName
  dateOfBirth
  firstName
  preferredName
  lastName
  pastDistributions
  relationships {
    id
    type
    toClientProfile {
      id
      firstName
    }
  }
}
    `;
export const BeneficiariesReport_NodeFragmentDoc = gql`
    fragment BeneficiariesReport_Node on Node {
  id
  __typename
  ... on Entity {
    entityKind: kind
  }
  ... on Proposal {
    cltProposal {
      id
    }
    crtProposal {
      id
    }
  }
  ... on HypotheticalGRAT {
    simulatedGrat {
      id
    }
  }
}
    `;
export const BeneficiariesReport_AccessAgeParameterViewFragmentDoc = gql`
    fragment BeneficiariesReport_AccessAgeParameterView on AccessAgeParameterView {
  ageEnd
  ageStart
}
    `;
export const BeneficiaiesReport_PercentageAccessParameterViewFragmentDoc = gql`
    fragment BeneficiaiesReport_PercentageAccessParameterView on PercentageAccessParameterView {
  kind
  frequency
  accessPercentage: percentage
  accessAgeParameters {
    ...BeneficiariesReport_AccessAgeParameterView
  }
}
    ${BeneficiariesReport_AccessAgeParameterViewFragmentDoc}`;
export const BeneficiariesReport_AmountAccessParameterViewFragmentDoc = gql`
    fragment BeneficiariesReport_AmountAccessParameterView on AmountAccessParameterView {
  kind
  accessAmount: amount
  frequency
  accessAgeParameters {
    ...BeneficiariesReport_AccessAgeParameterView
  }
}
    ${BeneficiariesReport_AccessAgeParameterViewFragmentDoc}`;
export const BeneficiariesReport_TrustIncomeAccessParameterViewFragmentDoc = gql`
    fragment BeneficiariesReport_TrustIncomeAccessParameterView on TrustIncomeAccessParameterView {
  kind
  amount
  frequency
  percentage
  accessAgeParameters {
    ...BeneficiariesReport_AccessAgeParameterView
  }
}
    ${BeneficiariesReport_AccessAgeParameterViewFragmentDoc}`;
export const BeneficiariesReport_DiscretionaryAccessParameterViewFragmentDoc = gql`
    fragment BeneficiariesReport_DiscretionaryAccessParameterView on DiscretionaryAccessParameterView {
  kind
  accessAgeParameters {
    ...BeneficiariesReport_AccessAgeParameterView
  }
}
    ${BeneficiariesReport_AccessAgeParameterViewFragmentDoc}`;
export const BeneficiariesReport_BeneficiaryReportEntityBreakdownFragmentDoc = gql`
    fragment BeneficiariesReport_BeneficiaryReportEntityBreakdown on BeneficiaryReportEntityBreakdown {
  _cacheKey
  node {
    ...BeneficiariesReport_Node
  }
  associatedObject {
    id
    ...BeneficiariesReport_Node
  }
  powerOfAppointment {
    id
    power
  }
  accessSource
  accessDetails
  accessDetailsSubtext
  beneficialAmount
  distributionFrequency
  displayName
  accessParametersResolved {
    ... on PercentageAccessParameterView {
      ...BeneficiaiesReport_PercentageAccessParameterView
    }
    ... on AmountAccessParameterView {
      ...BeneficiariesReport_AmountAccessParameterView
    }
    ... on TrustIncomeAccessParameterView {
      ...BeneficiariesReport_TrustIncomeAccessParameterView
    }
    ... on DiscretionaryAccessParameterView {
      ...BeneficiariesReport_DiscretionaryAccessParameterView
    }
  }
  scheduledDistribution {
    id
    ageRequirementStart
    ageRequirementEnd
  }
  dispositiveProvision {
    id
  }
  id
  entityValue
  notes
}
    ${BeneficiariesReport_NodeFragmentDoc}
${BeneficiaiesReport_PercentageAccessParameterViewFragmentDoc}
${BeneficiariesReport_AmountAccessParameterViewFragmentDoc}
${BeneficiariesReport_TrustIncomeAccessParameterViewFragmentDoc}
${BeneficiariesReport_DiscretionaryAccessParameterViewFragmentDoc}`;
export const BeneficiariesReport_BeneficiaryReportAccessBreakdownFragmentDoc = gql`
    fragment BeneficiariesReport_BeneficiaryReportAccessBreakdown on BeneficiaryReportAccessBreakdown {
  _cacheKey
  entities {
    ...BeneficiariesReport_BeneficiaryReportEntityBreakdown
  }
}
    ${BeneficiariesReport_BeneficiaryReportEntityBreakdownFragmentDoc}`;
export const BeneficiariesReport_BeneficiaryReportFutureAccessBreakdownFragmentDoc = gql`
    fragment BeneficiariesReport_BeneficiaryReportFutureAccessBreakdown on BeneficiaryReportFutureAccess {
  _cacheKey
  breakdown {
    ...BeneficiariesReport_BeneficiaryReportAccessBreakdown
  }
  milestones
  year
}
    ${BeneficiariesReport_BeneficiaryReportAccessBreakdownFragmentDoc}`;
export const BeneficiariesReport_BeneficiaryReportYearByYearBeneficiaryAccessFragmentDoc = gql`
    fragment BeneficiariesReport_BeneficiaryReportYearByYearBeneficiaryAccess on BeneficiaryReportYearByYearBeneficiaryAccess {
  _cacheKey
  age
  distributionsToDate
  milestones
  newTrustAccess
  trustAccessToDate
  year
}
    `;
export const BeneficiariesReport_BeneficiaryReportBeneficiaryBreakdownFragmentDoc = gql`
    fragment BeneficiariesReport_BeneficiaryReportBeneficiaryBreakdown on BeneficiaryReportBeneficiaryBreakdown {
  _cacheKey
  calculationMethod
  currentAccessAmount
  currentAccessBreakdown {
    ...BeneficiariesReport_BeneficiaryReportAccessBreakdown
  }
  futureAccessAmount
  futureDistributions
  futureAccessBreakdown {
    ...BeneficiariesReport_BeneficiaryReportFutureAccessBreakdown
  }
  beneficiaryAge
  pastDistributionAmount
  beneficiary {
    ...BeneficiariesReport_ClientProfile
  }
  orgBeneficiary {
    id
    name
  }
  yearByYearAccess {
    ...BeneficiariesReport_BeneficiaryReportYearByYearBeneficiaryAccess
  }
}
    ${BeneficiariesReport_BeneficiaryReportAccessBreakdownFragmentDoc}
${BeneficiariesReport_BeneficiaryReportFutureAccessBreakdownFragmentDoc}
${BeneficiariesReport_ClientProfileFragmentDoc}
${BeneficiariesReport_BeneficiaryReportYearByYearBeneficiaryAccessFragmentDoc}`;
export const BeneficiariesReport_EstateWaterfallMaterializedInputParamsFragmentDoc = gql`
    fragment BeneficiariesReport_EstateWaterfallMaterializedInputParams on EstateWaterfallMaterializedInputParams {
  firstGrantorDeathYear
  secondGrantorDeathYear
  selectedGrowthProfile {
    id
    displayName
  }
}
    `;
export const BeneficiariesReport_EstateWaterfallBeneficiaryReportFragmentDoc = gql`
    fragment BeneficiariesReport_EstateWaterfallBeneficiaryReport on EstateWaterfallBeneficiaryReport {
  _cacheKey
  beneficiariesMissingDateOfBirth {
    ...BeneficiariesReport_ClientProfile
  }
  beneficiariesBreakdown {
    ...BeneficiariesReport_BeneficiaryReportBeneficiaryBreakdown
  }
  materializedInputParams {
    ...BeneficiariesReport_EstateWaterfallMaterializedInputParams
  }
}
    ${BeneficiariesReport_ClientProfileFragmentDoc}
${BeneficiariesReport_BeneficiaryReportBeneficiaryBreakdownFragmentDoc}
${BeneficiariesReport_EstateWaterfallMaterializedInputParamsFragmentDoc}`;
export const BeneficiariesReport_EstateWaterfallFragmentDoc = gql`
    fragment BeneficiariesReport_EstateWaterfall on EstateWaterfall {
  id
  firstGrantorDeath {
    id
  }
  beneficiaryReport {
    ...BeneficiariesReport_EstateWaterfallBeneficiaryReport
  }
}
    ${BeneficiariesReport_EstateWaterfallBeneficiaryReportFragmentDoc}`;
export const BeneficiariesReportDocument = gql`
    query BeneficiariesReport($waterfallId: ID!, $householdId: ID!) {
  estateWaterfalls(
    where: {id: $waterfallId, hasHouseholdWith: [{id: $householdId}]}
  ) {
    edges {
      node {
        ...BeneficiariesReport_EstateWaterfall
      }
    }
  }
}
    ${BeneficiariesReport_EstateWaterfallFragmentDoc}`;

/**
 * __useBeneficiariesReportQuery__
 *
 * To run a query within a React component, call `useBeneficiariesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeneficiariesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeneficiariesReportQuery({
 *   variables: {
 *      waterfallId: // value for 'waterfallId'
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useBeneficiariesReportQuery(baseOptions: Apollo.QueryHookOptions<BeneficiariesReportQuery, BeneficiariesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeneficiariesReportQuery, BeneficiariesReportQueryVariables>(BeneficiariesReportDocument, withFetchPolicyContext(options));
      }
export function useBeneficiariesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeneficiariesReportQuery, BeneficiariesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeneficiariesReportQuery, BeneficiariesReportQueryVariables>(BeneficiariesReportDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useBeneficiariesReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BeneficiariesReportQuery, BeneficiariesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BeneficiariesReportQuery, BeneficiariesReportQueryVariables>(BeneficiariesReportDocument, withFetchPolicyContext(options));
        }
export type BeneficiariesReportQueryHookResult = ReturnType<typeof useBeneficiariesReportQuery>;
export type BeneficiariesReportLazyQueryHookResult = ReturnType<typeof useBeneficiariesReportLazyQuery>;
export type BeneficiariesReportSuspenseQueryHookResult = ReturnType<typeof useBeneficiariesReportSuspenseQuery>;
export type BeneficiariesReportQueryResult = Apollo.QueryResult<BeneficiariesReportQuery, BeneficiariesReportQueryVariables>;